import React, { useState, useEffect } from "react";
import { Table, Spinner, Button } from "react-bootstrap";
import { TiTick } from "react-icons/ti";
import instance from "../../services/baseService";
import toast from "react-hot-toast";
import { RiDeleteBin5Line } from "react-icons/ri";
function PortWiseTab({ scripNo, portCodeId, scripDate, gstNo, portCode, iecCode, tableHeaders, tableData, loading, callback, clientId, reportId, reportData,totalCount,totalAmount }) {

    const [loadingData, setLoadingData] = useState(false);

    const formatCurrency = (amount) => {
        if (!amount || amount === null || amount === undefined) return '₹0';
        const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
        return `₹${numAmount.toLocaleString('en-IN')}`;
    };

    const formatISODate = (d) => {
        return new Date(d).toLocaleDateString("en-GB", { timeZone: "UTC" });
    };

    const handleDeletePort = async () => {
        try {
            setLoadingData(true);
            const response = await instance.post(
                `/api/v1/reconciliation/port-code/delete/${clientId}/${reportId}/${portCodeId}`,
            );

            toast.success(response.data.message);
            callback();
        } catch (error) {
            console.error("Delete API Error:", error);
            toast.error(error.response?.data?.message || "Delete failed");
        } finally {
            setLoadingData(false);
        }
    };

    return (
        <>
            <div className="mb-4 d-flex flex-wrap  align-items-center gap-3 justify-content-between">
                {/* <RiDeleteBin5Line
                    size={20}
                    color="red"
                    className="cursor-pointer"
                    title="Delete Port Code"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDeletePort()}
                /> */}

                {reportData.manual_brc ? (
                    <Button
                        variant="danger"
                        size="sm"
                        className="fw-bold"
                        onClick={() => handleDeletePort()}
                        style={{ width: "100px" }}
                    >
                        Delete
                    </Button>
                ) : null}
                <div>
                    <strong className="me-2">Total Count:</strong>
                    <span>{totalCount ? totalCount : "N/A"}</span>
                </div>
                <div>
                    <strong className="me-2">Total Amount:</strong>
                    <span>{totalAmount ? totalAmount : "N/A"}</span>
                </div>
                <div>
                    <strong className="me-2">Scrip No:</strong>
                    <span>{scripNo ? scripNo : "N/A"}</span>
                </div>
                <div>
                    <strong className="me-2">Scrip Date:</strong>
                    <span>{scripDate ? formatISODate(scripDate) : "N/A"}</span>
                </div>
                <div>
                    <strong className="me-2">GST No:</strong>
                    <span>{gstNo ? gstNo : "N/A"}</span>
                </div>
                <div>
                    <strong className="me-2">Port Code:</strong>
                    <span>{portCode ? portCode : "N/A"}</span>
                </div>

                <div>
                    <strong className="me-2">IEC No:</strong>
                    <span>{iecCode ? iecCode : "N/A"}</span>
                </div>
            </div>
            <div className="overflow-auto" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (
                    <Table className="core-ui-table seperate-border">
                        <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
                            <tr>
                                {tableHeaders.map((header, index) => (
                                    <th key={index} style={{ whiteSpace: 'nowrap' }}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length > 0 ? (
                                tableData.map((row, rowIndex) => {
                                    const brcData = row.brc_data || [];
                                    const brcCount = brcData.length || 1; // At least 1 row even if empty

                                    return (
                                        <React.Fragment key={rowIndex}>
                                            {brcCount === 0 || brcData.length === 0 ? (
                                                // No BRC data - show single row with N/A
                                                <tr>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{rowIndex +1}</td>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{row.sbNo}</td>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{row.sbDate}</td>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{row.scrollNo}</td>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{row.status}</td>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{row.type}</td>
                                                    <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{formatCurrency(row.amount)}</td>
                                                    <td className="text-left text-muted" style={{ whiteSpace: 'nowrap' }}>N/A</td>
                                                    <td className="text-left text-muted" style={{ whiteSpace: 'nowrap' }}>N/A</td>
                                                    <td className="text-left text-muted" style={{ whiteSpace: 'nowrap' }}>N/A</td>
                                                    <td className="text-left text-muted" style={{ whiteSpace: 'nowrap' }}>N/A</td>
                                                    <td className="text-left text-muted" style={{ whiteSpace: 'nowrap' }}>N/A</td>
                                                </tr>
                                            ) : (
                                                // Has BRC data - show multiple rows with rowSpan for IceGate columns
                                                brcData.map((brc, brcIndex) => (
                                                    <tr key={`${rowIndex}-${brcIndex}`}>
                                                        {/* IceGate columns - only show in first row with rowSpan */}
                                                        {brcIndex === 0 && (
                                                            <>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{rowIndex +1}</td>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{row.sbNo}</td>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{row.sbDate}</td>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{row.scrollNo}</td>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{row.status}</td>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{row.type}</td>
                                                                <td className="text-left" style={{ whiteSpace: 'nowrap' }} rowSpan={brcCount}>{formatCurrency(row.amount)}</td>
                                                            </>
                                                        )}
                                                        {/* BRC/DGFT columns - show for each brc_data entry */}
                                                        <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{formatCurrency(brc.fob)}</td>
                                                        <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{brc.brc_no || ''}</td>
                                                        <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{brc.brc_date || ''}</td>
                                                        <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{formatCurrency(brc.brc_realised_value)}</td>
                                                        <td className="text-left" style={{ whiteSpace: 'nowrap' }}>{row.ifsc_code || 'N/A'}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={tableHeaders.length} className="text-center py-4">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                )}
            </div>
        </>
    );
}

export default PortWiseTab;